import { useState } from 'react';
import PropTypes from 'prop-types';
import { SubscriptionForm } from './SubscriptionForm';
import {
  SuccessHeading,
  SuccessDescription,
  ResponseError,
  SectionFooter,
} from './SubscriptionFormSnippets';
import './SubscriptionSection.scss';

export const SubscriptionSection = (props) => {
  const { headerText, descriptionText, buttonText, subscriptionImageUrl } = props;
  const [showSuccessMessage, setShowSuccessMessage] = useState();
  const [showResponseErrorMessage, setShowResponseErrorMessage] = useState();

  const backgroundImage = subscriptionImageUrl;

  const heading = showSuccessMessage ? <SuccessHeading /> : headerText;
  const description = showSuccessMessage ? <SuccessDescription /> : descriptionText;

  const onSuccessHandler = () => {
    setShowSuccessMessage(true);
  };

  const onResponseErrorHandler = (boolean) => {
    setShowResponseErrorMessage(boolean);
  };

  const sectionClasses = `subscription-section ${showResponseErrorMessage ? 'server-error' : ''}`;

  const backgroundImageStyles = {
    backgroundImage: `url(${backgroundImage})`,
  };

  return (
    <section
      className={sectionClasses}
      style={backgroundImageStyles}
      data-testid="subscription-section"
    >
      <div className="section-background" />
      <div className="section-contents">
        <h2 className="subscription-section__heading" data-testid="heading">
          {heading}
        </h2>
        <p className="subscription-section__description large" data-testid="description">
          {description}
        </p>
        {showResponseErrorMessage && <ResponseError />}
        <SubscriptionForm
          onSuccessHandler={onSuccessHandler}
          onResponseErrorHandler={onResponseErrorHandler}
          buttonText={buttonText}
        />
        <SectionFooter />
      </div>
    </section>
  );
};

export const SubscriptionSectionSC = (props) => {
  const { sitecoreData } = props;
  return <SubscriptionSection {...sitecoreData} />;
};

SubscriptionSection.propTypes = {
  headerText: PropTypes.string.isRequired,
  descriptionText: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  subscriptionImageUrl: PropTypes.string,
};

SubscriptionSectionSC.propTypes = {
  sitecoreData: PropTypes.func,
};
